import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { packs } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
export function Pricing() {
  return <section id="precios" className="w-full bg-paper py-20 md:py-28" aria-labelledby="precios-title" data-id="element-127" data-mp="2oj8s3pcc6fhb">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-128" data-mp="2jj4b7y7iniqk">
        <h2 id="precios-title" className="text-center text-4xl font-extrabold tracking-tightest text-ink md:text-5xl" data-id="element-129" data-mp="2jlpdupfn22pd">
          Elegí tu pack
        </h2>

        <div className="mt-12 grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:items-stretch" data-id="element-130" data-mp="1ru9jg97ubbol">
          {packs.map(pack => {
          const featured = pack.featured;
          return <div key={pack.id} className={['flex h-full flex-col rounded-3xl p-7 md:p-10', featured ? 'bg-ink text-white ring-1 ring-ink' : 'bg-paper-card text-ink ring-1 ring-line'].join(' ')} data-id="element-131" data-mp="20v7pex1u9t9t">
                <div className="flex items-start justify-between gap-4" data-id="element-132" data-mp="4smeqrpnc5zb">
                  <p className={['flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em]', featured ? 'text-accent' : 'text-ink-muted'].join(' ')} data-id="element-133" data-mp="4uyvx2nkycbb">
                    <span aria-hidden="true" className="text-base" data-id="element-134" data-mp="3daigzee3kofa">
                      {pack.emoji}
                    </span>
                    {pack.name}
                  </p>
                  {pack.tagline ? <span className="shrink-0 rounded-full bg-accent px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-135" data-mp="3n5ahapz2dpdr">
                      {pack.tagline}
                    </span> : null}
                </div>

                <p className={['mt-4 text-lg font-semibold leading-snug tracking-tight', featured ? 'text-white' : 'text-ink'].join(' ')} data-id="element-136" data-mp="2zgiuyf85o18w">
                  {pack.subtitle}
                </p>

                <ul className="mt-7 space-y-3" data-id="element-137" data-mp="316xqj7lc6y8w">
                  {pack.features.map(feature => <li key={feature} className="flex items-start gap-3 text-[15px] leading-snug" data-id="element-138" data-mp="2w7bev2l5pq27">
                      <CheckIcon className={['mt-0.5 h-4 w-4 shrink-0', featured ? 'text-accent' : 'text-accent'].join(' ')} strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="28h7dl1vfy2ed" />
                      <span className={featured ? 'text-white/85' : 'text-ink-muted'} data-id="element-140" data-mp="2dfsb2tjb67z4">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <div className="mt-auto pt-10" data-id="element-141" data-mp="3oyd1for6invr">
                  <div className="flex items-baseline gap-3" data-id="element-142" data-mp="a41llomekma">
                    <span className={['text-base font-semibold line-through', featured ? 'text-white/40' : 'text-ink-muted'].join(' ')} data-id="element-143" data-mp="59gpm9r89xqg">
                      {pack.priceBefore}
                    </span>
                    <span className={['text-5xl font-extrabold tracking-tightest md:text-6xl', featured ? 'text-white' : 'text-ink'].join(' ')} data-id="element-144" data-mp="j0d6x4fpesi7">
                      {pack.price}
                    </span>
                    <span className={['text-sm font-bold uppercase', featured ? 'text-white/50' : 'text-ink-muted'].join(' ')} data-id="element-145" data-mp="e93k0blji3a0">
                      ARS
                    </span>
                  </div>

                  <a href={pack.url} onClick={() => trackPixelEvent('InitiateCheckout', {
                content_name: pack.name,
                value: Number(pack.price.replace(/[^0-9]/g, '')),
                currency: 'ARS'
              })} className={['group mt-6 flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-base font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2', featured ? 'bg-accent text-white hover:bg-accent-dark focus-visible:ring-accent focus-visible:ring-offset-ink' : 'bg-ink text-white hover:bg-ink-soft focus-visible:ring-ink focus-visible:ring-offset-paper-card'].join(' ')} data-id="element-146" data-mp="3f8toc7mv34f5">
                    {pack.cta}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-147" data-mp="1ygpx06lh2azi" />
                  </a>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-8 text-center text-sm font-medium text-ink-muted" data-id="element-148" data-mp="2cg7kmin17i7a">
          Pago seguro · Acceso en 5 min · Mercado Pago · Tarjeta · Transferencia
        </p>
      </div>
    </section>;
}